import React, { useState } from 'react';
import {Row, Col, Form, InputNumber} from 'antd';
import './ComponentsStylesheet.css';

const Component = ({ height = 50, style }) => {
    return <div className="spacer-block" style={{...style, height : height + 'px'}}/>;
};

const EditForm = props => {
    const { getFieldDecorator } = props.form;
    const [height, setHeight] = useState(props.height);

    return (        
        <React.Fragment>
            <Row type="flex" justify="space-around" style={{ marginBottom: '1rem' }}>
                <Col span={24} >
                    <Component height={height} style={{border: "#d9d9d9 1px solid", boxShadow: "#e6e6e6 2.5px 2.5px 5px 2px"}}/>
                </Col>
            </Row>
            <Row type="flex" justify="start" style={{ marginBottom: '1rem' }}>
                <Col span={6} >
                    <Form.Item label="Height" required>
                        {getFieldDecorator('height', { initialValue: props.height })(<InputNumber name="height" placeholder="height in px" onChange={setHeight} style={{ width: '100%' }} />)}
                    </Form.Item>
                </Col>
            </Row>            
        </React.Fragment>
    );
};
EditForm.defaultProps = {
    height: 50
};

export { Component, EditForm };
